// Browser-only sanitize helpers (the Vite app has no server rendering; the
// old jsdom-based SSR branch died with Next.js).
import DOMPurify from 'dompurify'

/**
 * Sanitize a string of user input to prevent XSS/injection attacks.
 * @param input The user input string
 * @returns The sanitized string
 */
export function sanitize(input: string): string {
  return DOMPurify.sanitize(input, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] }) // strips all HTML
}

/**
 * Sanitize HTML input but allow basic formatting (optional)
 * @param input The user input string
 * @returns The sanitized HTML string
 */
export function sanitizeHtml(input: string): string {
  return DOMPurify.sanitize(input) // allows safe HTML
}
